// extracted by mini-css-extract-plugin
export default {"title":"Preferences_title__uOdof","preferences":"Preferences_preferences__8jmy6","detail":"Preferences_detail__yPM1o","manage":"Preferences_manage__SFtxa"};